// Rango de meses completos «desde – hasta» (YYYY-MM) del resumen mes a mes.

const MONTH_RE = /^\d{4}-(0[1-9]|1[0-2])$/;

/**
 * Un mes completo de un año razonable. El selector de mes de Chrome emite años
 * a medio teclear («0002-10», «0020-10») antes del definitivo: esos no cuentan.
 */
export const isMonth = (value: unknown): value is string => {
  const v = String(value ?? "");
  if (!MONTH_RE.test(v)) return false;
  const year = Number(v.slice(0, 4));
  return year >= 2000 && year <= 2100;
};

const index = (period: string) => Number(period.slice(0, 4)) * 12 + Number(period.slice(5, 7)) - 1;

/** Meses que abarca el rango, contando los dos extremos; 0 si alguno no es un mes. */
export function monthsBetween(from: string, to: string): number {
  if (!isMonth(from) || !isMonth(to)) return 0;
  return Math.max(0, index(to) - index(from) + 1);
}

/**
 * Deja un rango utilizable a partir de lo que escribió la persona: un extremo
 * vacío o inválido conserva el anterior, y si quedan al revés se mueve el OTRO
 * extremo para que el que se acaba de cambiar sea el que manda.
 */
export function applyMonthRange(current: { from: string; to: string }, change: { from?: string; to?: string }): { from: string; to: string } {
  let { from, to } = current;
  if (change.from !== undefined && isMonth(change.from)) {
    from = change.from;
    if (from > to) to = from;
  }
  if (change.to !== undefined && isMonth(change.to)) {
    to = change.to;
    if (to < from) from = to;
  }
  return { from, to };
}
